webpackJsonp([233427756548064],{

/***/ 400:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>An article I wrote :)</p>\n<p><a href=\"/how-should-i-test-my-react-components\">How should I test my React components?</a></p>","frontmatter":{"title":"My work","date":null}}},"pathContext":{"slug":"/my-work","prev":{"fields":{"slug":"/sydney-new-zealand-journal"},"frontmatter":{"title":"Sydney & New Zealand journal"}},"next":{"fields":{"slug":"/weird-about-us"},"frontmatter":{"title":"Weird about US"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---my-work-6b81a30e20f18646c7f8.js